import React from 'react';
import _ from 'lodash';
import { toast } from 'react-toastify';
import { WarningToast } from 'components/Toast';

export const AI_IMAGE_GENERATING_BLOCKED_MESSAGE =
  'This action is unavailable while an AI image is being generated.';

export const isWidgetAiImageGenerating = (widget) =>
  Boolean(widget && _.get(widget, 'content.aiEditing'));

export const isSelectionBlockedForAiImageGeneration = (selectedWidgets = []) =>
  (selectedWidgets || []).some(isWidgetAiImageGenerating);

export const isPasteBlockedDuringAiImageGeneration = (allWidgets = []) =>
  (allWidgets || []).some(isWidgetAiImageGenerating);

const AI_IMAGE_GENERATING_TOAST_ID = 'ai-image-generating-blocked';

export const showAiImageGeneratingBlockedToast = () => {
  if (toast.isActive(AI_IMAGE_GENERATING_TOAST_ID)) {
    return;
  }

  toast(
    <WarningToast
      heading="Please wait"
      description={AI_IMAGE_GENERATING_BLOCKED_MESSAGE}
    />,
    {
      type: toast.TYPE.DEFAULT,
      position: toast.POSITION.BOTTOM_RIGHT,
      autoClose: 3000,
      toastId: AI_IMAGE_GENERATING_TOAST_ID,
    }
  );
};

export const blockClipboardOperation = (selectedWidgets, { showToast = true } = {}) => {
  if (isSelectionBlockedForAiImageGeneration(selectedWidgets)) {
    if (showToast) {
      showAiImageGeneratingBlockedToast();
    }
    return true;
  }
  return false;
};

export const blockPasteOperation = (allWidgets, { showToast = true } = {}) => {
  if (isPasteBlockedDuringAiImageGeneration(allWidgets)) {
    if (showToast) {
      showAiImageGeneratingBlockedToast();
    }
    return true;
  }
  return false;
};

export const blockDeleteOperation = (selectedWidgets, { showToast = true } = {}) => {
  if (isSelectionBlockedForAiImageGeneration(selectedWidgets)) {
    if (showToast) {
      showAiImageGeneratingBlockedToast();
    }
    return true;
  }
  return false;
};
